const updates = [
  {
    date: '2026-07-29',
    tag: '新番上线',
    title: '七月新番《XXX》第 1 集上线',
    desc: '51动漫官网已同步上线七月新番，支持在线观看和免费下载，下拉式追更模式让你一口气看完。',
  },
  {
    date: '2026-07-28',
    tag: '资源更新',
    title: '《斗罗大陆》最新一集更新',
    desc: '国漫热门大作《斗罗大陆》唐三激战深海魔鲸王，51动漫官网已更新最新一集高清资源。',
  },
  {
    date: '2026-07-27',
    tag: '番剧完结',
    title: '《葬送的芙莉莲》第一季完结收录',
    desc: '年度口碑日漫《葬送的芙莉莲》第一季全集已在51动漫官网完整上线，支持一键下载全部集数。',
  },
  {
    date: '2026-07-26',
    tag: '韩漫更新',
    title: '《我独自升级》最新话追更推送',
    desc: '热门韩漫《我独自升级》最新一话已更新，51动漫官网下拉式阅读模式适配长条韩漫体验。',
  },
  {
    date: '2026-07-25',
    tag: '站点公告',
    title: '51动漫官网播放器全面升级',
    desc: '播放引擎升级后画质更清晰，加载速度提升 30%，支持记忆播放进度，追番更便捷。',
  },
  {
    date: '2026-07-24',
    tag: '新番上线',
    title: '七月新番第二波集中上线',
    desc: '本周第二批七月新番已全部上线51动漫官网，涵盖热血、恋爱、搞笑等多种类型任你挑选。',
  },
  {
    date: '2026-07-23',
    tag: '国漫推荐',
    title: '《完美世界》系列大事件更新',
    desc: '石昊闯入上界引发各方震动，51动漫官网已同步更新《完美世界》最新剧情，高燃不容错过。',
  },
  {
    date: '2026-07-22',
    tag: '站点公告',
    title: '51动漫下载功能优化完成',
    desc: '全站动漫下载速度提升，新增批量下载功能，支持同时下载多集动漫全集离线观看。',
  },
  {
    date: '2026-07-21',
    tag: '热门排行',
    title: '本周人气排行 TOP10 榜单出炉',
    desc: '《斗罗大陆》连续三周霸榜，《咒术回战》紧随其后，快来看看你追的番排第几。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-10">
          最新动态
        </h2>
        <div className="max-w-[720px] mx-auto">
          {updates.map((item, i) => (
            <div
              key={i}
              className="flex gap-4 md:gap-5 pb-6 md:pb-7 last:pb-0"
            >
              <div className="flex flex-col items-center flex-shrink-0">
                <div className="w-2.5 h-2.5 rounded-full bg-primary-500 mt-1.5"></div>
                {i < updates.length - 1 && (
                  <div className="w-px flex-1 bg-background-200 mt-1.5"></div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className="text-xs text-foreground-400">{item.date}</span>
                  <span className="text-xs font-medium bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}